import { getBufferSnapshot, getEntriesSince } from 'helpers/diagnostics'

export interface CapturedError {
  message: string
  stack?: string
  network: { url: string; method: string; status: number; error?: string }[]
  console: { level: string; message: string }[]
}

export interface CaptureResult {
  success: boolean
  error?: CapturedError
}

export async function withErrorCapture(fn: () => Promise<void> | void): Promise<CaptureResult> {
  const snapshot = getBufferSnapshot()

  try {
    await fn()
    return { success: true }
  } catch (err: any) {
    const entries = getEntriesSince(snapshot)
    return {
      success: false,
      error: {
        message: err?.message || String(err),
        stack: err?.stack,
        network: entries.network.map((e) => ({
          url: e.endpoint,
          method: e.method,
          status: e.status ?? 0,
          error: e.error
        })),
        console: entries.console.map((e) => ({
          level: e.level,
          message: e.message
        }))
      }
    }
  }
}
